module.exports = __webpack_public_path__ + "static/media/sjølvfølgje-new.a8815ff5.mp3";